module.exports = __webpack_public_path__ + "static/assets/9cc1e7a12b63848899055ddc982ab2ce.svg";